module.exports = __webpack_public_path__ + "static/media/bac.6278396a.jpg";